export default "__VITE_ASSET__da4af781__"